module.exports = __webpack_public_path__ + "static/media/Dayly_ios_4.84c02910.jpg";